/* eslint-disable react/display-name */
import {
  Box,
  Button,
  Drawer,
  Grid,
  Paper,
  TablePagination,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  AddCircleRounded,
  CalendarToday,
  Cancel,
  CheckCircleRounded,
  CloudDownload,
  Delete,
  DeleteOutlined,
  FilterList,
  Publish,
  Search
} from "@material-ui/icons";
import { format, startOfDay } from "date-fns";
import { useTranslation } from "react-i18next";

import { findIndex } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { FiPaperclip } from "react-icons/fi";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { useSlots } from "../../../hooks/useSlots";
import { actionShowSpinner } from "../../../redux-flow/action/Wrapper/Spinner";
import { downloadFile } from "../../../services/fileManagement.service";
import {
  addFileSlot,
  deleteFileSlot,
  getAll,
} from "../../../services/slots.service";
import {
  getDateFormats,
  getDateTimeLocale,
} from "../../../utils/get-date-time-locale";
import { DialogCustom } from "../../Common/Dialog";
import DialogConfirmation from "../../Common/DialogCustom";
import { Table } from "../../Common/Table";
import ToastMessage from "../../Common/ToastMessage";
import { slotStatus } from "../utils/index";
import CustomGroupRow from "./CustomGroupRow";
import FilterDrawer from "./FilterDrawer";
import { Dropzone, FieldInfo, FilesContainer } from "./styles";

import { useAuth } from "../../../context/auth";
import { useSlotList } from "../../../context/lists/slotList";
import FileReaderComponent from "../../Common/FileReader";
import { Select } from "../../Common/Select";
import ModalBase from "../../Pages/utils/ModalBase";
import UnsuportedFileModal from "../fileManagement/modals/UnsuportedFIle";
import { checkAccess } from "../utils/index";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
    width: "100%",
  },
  tableDetail: {
    maxWidth: "55vw",
  },
  committeeSummary: {
    width: "20vw",
    marginLeft: 20,
  },
  button: {
    ...theme.typography.subtitle1,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    textTransform: "uppercase",
    minWidth: 180,
    minHeight: 50,
    borderRadius: 25,
    marginTop: "5vh",
  },
  filterButton: {
    ...theme.typography.subtitle1,
    backgroundColor: "#fff",
    color: "#666666",
    borderRadius: 8,
    border: "1px solid #666666",
    textTransform: "uppercase",
    maxWidth: 140,
    width: "100%",
  },
  spacer: {
    marginBottom: 20,
  },
  visibleOn: {
    marginRight: 20,
    color: theme.palette.secondary.main,
  },
  visibleOff: {
    marginRight: 20,
    color: theme.palette.action.main,
  },
  active: {
    ...theme.typography.subtitle1,
    color: theme.palette.action.contrastText,
  },
  inactive: {
    ...theme.typography.subtitle1,
    color: theme.palette.action.light,
  },
  active: {
    ...theme.typography.subtitle1,
    color: theme.palette.success.dark,
  },
  inactive: {
    ...theme.typography.subtitle1,
    color: theme.palette.warning.dark,
  },
  error: {
    backgroundColor: theme.palette.error.dark,
    borderRadius: 5,
    height: 50,
  },
  success: {
    backgroundColor: theme.palette.success.dark,
    borderRadius: 5,
    height: 50,
  },
  label: {
    ...theme.typography.subtitle1,
    color: theme.palette.primary.contrastText,
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: 30,
    marginRight: 50,
  },
  title: {
    fontWeight: "bold",
    fontSize: "1.25rem",
    color: theme.palette.primary.main,
    marginBottom: 20,
  },
}));

const ListSlots = ({ t, history, actionShowSpinner, location }) => {
  const classes = useStyles();
  const { userAccess } = useAuth();
  const { listOptions, updateFilterParams, updatePagination } = useSlotList();
  const { i18n } = useTranslation();

  const fileTypes = [
    { id: 1, name: t("fileTypes.action") },
    { id: 2, name: t("fileTypes.schedule") },
    { id: 3, name: t("fileTypes.minutes") },
    { id: 4, name: t("fileTypes.statementOfDeliberation") },
    { id: 5, name: t("fileTypes.forms") },
    { id: 6, name: t("fileTypes.supportMaterial") },
  ];

  const [successDeletedState, setSuccessDeletedState] = useState(
    location?.state?.successDeleteSlot
  );
  const [successCreatedState, setSuccessCreatedState] = useState(
    location?.state?.successCreateSlot
  );
  const [successUpdatedState, setSuccessUpdatedState] = useState(
    location?.state?.successUpdateSlot
  );
  const [successDisabledState, setSuccessDisabledState] = useState(
    location?.state?.successDisabledSlot
  );
  const [successEnabledState, setSuccessEnabledState] = useState(
    location?.state?.successEnabledSlot
  );
  const [filesUploadedSuccess, setFilesUploadedSuccess] = useState(false);
  const [filesUploadedError, setFilesUploadedError] = useState(false);
  const [totalSlots, setTotalSlots] = useState(0);

  const [openDialog, setOpenDialog] = useState(false);
  const [value, setValue] = useState({});
  const [filesUpload, setFiles] = useState([]);
  const [filesOriginal, setFilesOriginal] = useState([]);
  const [filesAnexo, setFilesAnexo] = useState([]);
  const [dataTableFilesUpload, setDataTableFilesUpload] = useState([]);
  const [slotIdSelected, setSlotIdSelected] = useState("");
  const [slotCommitteeIdSelected, setSlotCommitteeIdSelected] = useState("");
  const [showDeleteConfirmationOpen, setShowDeleteConfirmationOpen] =
    useState(false);
  const [idSelectedForDeleteFile, setIdSelectedForDeleteFile] = useState(false);
  const [filesSlots, setFilesSlots] = useState([]);
  const [saveLoading, setSaveLoading] = useState(false);
  const [filesUploadedErrorMessage, setFilesUploadedErrorMessage] = useState();
  const [toastMessage, setToastMessage] = useState({
    message: "Essa ordenação não está disponível.",
    type: "error",
    open: false,
  });

  const { getFilesSlot, slotFiles, success } = useSlots({
    spinner: actionShowSpinner,
  });

  const deleteFilePersist = () => {
    deleteFileSlot(idSelectedForDeleteFile).then((response) => {
      setShowDeleteConfirmationOpen(false);
      fetchSlots();
      setOpenDialog(false);

      if (response.error) {
        setToastMessage({
          message: response.error,
          type: "error",
          open: true,
        });
      }
    });
  };

  const [formattedSlots, setFormattedSlots] = useState([]);

  const [canAttachFile, setCanAttachFile] = useState(false);
  const [canCreateSlot, setCanCreateSlot] = useState(false);
  const [canUpdateSlot, setCanUpdateSlot] = useState(false);
  const [canViewSlotCommitteeDetails, setCanViewSlotCommitteeDetails] =
    useState(false);
  const [filterDrawerOpened, setFilterDrawerOpened] = useState(false);
  const [openedFile, setOpenedFile] = useState(null);
  const [showUnsuportedFileModal, setShowUnsuportedFileModal] = useState(false);
  const [unsuportedFileBlobUrl, setUnsuportedFileBlobUrl] = useState("");
  const [fileType, setFileType] = useState("");
  const [fileName, setFileName] = useState("");

  const fetchSlots = useCallback(async () => {
    actionShowSpinner(true);

    try {
      const response = await getAll({
        ...(listOptions.filterParams.status && {
          status: listOptions.filterParams.status.map((s) => s.id),
        }),
        ...(listOptions.filterParams.presenters && {
          presenters: listOptions.filterParams.presenters.map((p) => p.id),
        }),
        ...(listOptions.filterParams.companies && {
          companyIds: listOptions.filterParams.companies.map((c) => c.id),
        }),
        ...(listOptions.filterParams.requestId && {
          requestId: listOptions.filterParams.requestId.id,
        }),
        ...(listOptions.filterParams.directorship && {
          directorship: listOptions.filterParams.directorship.id,
        }),
        ...(listOptions.filterParams.kind && {
          kind: listOptions.filterParams.kind.id,
        }),
        ...(listOptions.filterParams.budgeted && {
          budgeted: listOptions.filterParams.budgeted.id,
        }),
        ...(listOptions.filterParams.modalityId && {
          modalityId: listOptions.filterParams.modalityId.id,
        }),
        ...(listOptions.filterParams.committees && {
          committees: listOptions.filterParams.committees.map((c) => c.id),
        }),
        ...(listOptions.filterParams.startDate && {
          startDate: startOfDay(listOptions.filterParams.startDate),
        }),
        ...(listOptions.filterParams.endDate && {
          endDate: startOfDay(listOptions.filterParams.endDate),
        }),
        ...(listOptions.filterParams.statusMaterial && {
          statusMaterial: listOptions.filterParams.statusMaterial.id,
        }),
        ...(listOptions.filterParams.keyWord && {
          keyWord: listOptions.filterParams.keyWord,
        }),
        pageSize: listOptions.pagination.size,
        currentPage: listOptions.pagination.page,
      });

      if (response.error.length > 0) {
        setFormattedSlots([]);
        setTotalSlots(0);

        return;
      }

      const newSlots = response.data.items.map((slot) => {
        const formattedSupportMaterialIndicator = slot.hasSupportMaterial ? (
          <FiPaperclip />
        ) : (
          ""
        );

        const saoPauloOffset = -3 * 60; // Sao Paulo is UTC-3

        let slotDateInBrazilianTimezone = undefined;

        if (slot.meetDateTime) {
          const utcDate = new Date(slot.meetDateTime);
          slotDateInBrazilianTimezone = new Date(
            utcDate.getTime() + saoPauloOffset * 60 * 1000
          );
        }

        return {
          ...slot,
          slotId: slot.id,
          status: slot.status,
          hosts: slot.slotHosts.map((host) => host.userName).join(" | "),
          slotStatusCode: slot.status,
          committee: slot.committeeName,
          meetDateTime: !slot?.meetDateTime
            ? ""
            : format(
                slotDateInBrazilianTimezone,
                getDateFormats(i18n.language),
                {
                  locale: getDateTimeLocale(i18n.language),
                }
              ),
          supportMaterialIndicator: formattedSupportMaterialIndicator,
        };
      });

      setTotalSlots(response.data.countItems);
      setFormattedSlots(newSlots);
    } catch (e) {
      setToastMessage({
        message: t("error"),
        type: "error",
        open: true,
      });
    } finally {
      actionShowSpinner(false);
    }
  }, [listOptions]);

  useEffect(() => {
    const loadData = async () => {
      actionShowSpinner(true);

      try {
        const response = await getAll({
          ...(listOptions.filterParams.status && {
            status: listOptions.filterParams.status.map((s) => s.id),
          }),
          ...(listOptions.filterParams.presenters && {
            presenters: listOptions.filterParams.presenters.map((p) => p.id),
          }),
          ...(listOptions.filterParams.companies && {
            companyIds: listOptions.filterParams.companies.map((c) => c.id),
          }),
          ...(listOptions.filterParams.requestId && {
            requestId: listOptions.filterParams.requestId.id,
          }),
          ...(listOptions.filterParams.directorship && {
            directorship: listOptions.filterParams.directorship.id,
          }),
          ...(listOptions.filterParams.kind && {
            kind: listOptions.filterParams.kind.id,
          }),
          ...(listOptions.filterParams.budgeted && {
            budgeted: listOptions.filterParams.budgeted.id,
          }),
          ...(listOptions.filterParams.modalityId && {
            modalityId: listOptions.filterParams.modalityId.id,
          }),
          ...(listOptions.filterParams.committees && {
            committees: listOptions.filterParams.committees.map((c) => c.id),
          }),
          ...(listOptions.filterParams.startDate && {
            startDate: startOfDay(listOptions.filterParams.startDate),
          }),
          ...(listOptions.filterParams.endDate && {
            endDate: startOfDay(listOptions.filterParams.endDate),
          }),
          ...(listOptions.filterParams.statusMaterial && {
            statusMaterial: listOptions.filterParams.statusMaterial.id,
          }),
          ...(listOptions.filterParams.keyWord && {
            keyWord: listOptions.filterParams.keyWord,
          }),
          pageSize: listOptions.pagination.size,
          currentPage: listOptions.pagination.page,
        });

        if (response.error.length > 0) {
          setFormattedSlots([]);
          setTotalSlots(0);

          return;
        }

        const newSlots = response.data.items.map((slot) => {
          const formattedSupportMaterialIndicator = slot.hasSupportMaterial ? (
            <FiPaperclip />
          ) : (
            ""
          );

          const saoPauloOffset = -3 * 60; // Sao Paulo is UTC-3

          let slotDateInBrazilianTimezone = undefined;

          if (slot.meetDateTime) {
            const utcDate = new Date(slot.meetDateTime);
            slotDateInBrazilianTimezone = new Date(
              utcDate.getTime() + saoPauloOffset * 60 * 1000
            );
          }

          return {
            ...slot,
            slotId: slot.id,
            status: slot.status,
            hosts: slot.slotHosts.map((host) => host.userName).join(" | "),
            slotStatusCode: slot.status,
            committee: slot.committeeName,
            meetDateTime: !slot?.meetDateTime
              ? ""
              : format(
                  slotDateInBrazilianTimezone,
                  getDateFormats(i18n.language),
                  {
                    locale: getDateTimeLocale(i18n.language),
                  }
                ),
            supportMaterialIndicator: formattedSupportMaterialIndicator,
          };
        });

        setTotalSlots(response.data.countItems);
        setFormattedSlots(newSlots);
      } catch (e) {
        setToastMessage({
          message: t("error"),
          type: "error",
          open: true,
        });
      } finally {
        actionShowSpinner(false);
      }
    };

    if (userAccess) {
      const hasAccess = checkAccess(userAccess, "listSlots");
      const hasAccessToAttachFile = checkAccess(userAccess, "attachFileSlot");
      const hasAccessToCreateSlot = checkAccess(userAccess, "createSlot");
      const hasAccessToUpdateSlot = checkAccess(userAccess, "updateSlot");
      const hasAccessToViewSlotCommitteeDetails = checkAccess(
        userAccess,
        "viewSlotDetails"
      );

      setCanAttachFile(hasAccessToAttachFile);
      setCanCreateSlot(hasAccessToCreateSlot);
      setCanUpdateSlot(hasAccessToUpdateSlot);
      setCanViewSlotCommitteeDetails(hasAccessToViewSlotCommitteeDetails);

      if (!hasAccess) {
        history.push("/");
      }

      loadData();
    }
  }, [listOptions, userAccess, history, i18n.language]);

  useEffect(() => {
    if (success.deleteFileSlot === "deleteFileSlot")
      getFilesSlot(slotCommitteeIdSelected);
  }, [success]);

  useEffect(() => {
    if (
      typeof location?.state?.successDeleteSlot === "boolean" &&
      location?.state?.successDeleteSlot
    ) {
      setTimeout(() => setSuccessDeletedState(false), 10000);
    }

    if (
      typeof location?.state?.successCreateSlot === "boolean" &&
      location?.state?.successCreateSlot
    ) {
      setTimeout(() => setSuccessCreatedState(false), 10000);
    }

    if (
      typeof location?.state?.successUpdateSlot === "boolean" &&
      location?.state?.successUpdateSlot
    ) {
      setTimeout(() => setSuccessUpdatedState(false), 10000);
    }

    if (
      typeof location?.state?.successDisabledSlot === "boolean" &&
      location?.state?.successDisabledSlot
    ) {
      setTimeout(() => setSuccessDisabledState(false), 10000);
    }

    if (
      typeof location?.state?.successEnabledSlot === "boolean" &&
      location?.state?.successEnabledSlot
    ) {
      setTimeout(() => setSuccessEnabledState(false), 10000);
    }
  }, []);

  const saveSlot = async () => {
    try {
      setSaveLoading(true);

      const formData = new FormData();

      let count = 0;

      for (const file of filesFormData) {
        formData.append(`fromFilesInputs[${count}].fileType`, file.fileType);
        formData.append(`fromFilesInputs[${count}].fromFiles`, file);

        count += 1;
      }

      const addFileSlotReturn = await addFileSlot({
        formData,
        id: slotIdSelected,
        slotCommitteeId: slotCommitteeIdSelected,
      });

      setOpenDialog(false);
      setFilesFormData([]);
      fetchSlots();

      if (!addFileSlotReturn.error) {
        const newFormattedSlots = formattedSlots.map((item) => {
          if (item.slotId === slotIdSelected) {
            return {
              ...item,
              hosts: item.slotHosts.map((host) => host.userName).join(" | "),
              supportMaterialIndicator: <FiPaperclip />,
            };
          }

          return item;
        });

        setFormattedSlots(newFormattedSlots);

        setFilesUploadedSuccess(true);
        setTimeout(() => setFilesUploadedSuccess(false), 10000);
      } else {
        if (typeof addFileSlotReturn.error === "string") {
          setFilesUploadedErrorMessage(addFileSlotReturn.error);
        }
        setFilesUploadedError(true);
        setTimeout(() => setFilesUploadedError(false), 10000);
      }
    } catch (e) {
    } finally {
      setSaveLoading(false);
    }
  };

  useEffect(() => {
    setDataTableFilesUpload(
      slotFiles.map((item) => ({
        name: item.fileName,
        fileTypeName: item.fileType,
        id: item.fileId,
        isPersisted: true,
      }))
    );
  }, [slotFiles]);

  const handleClearList = () => {
    setDataTableFilesUpload([]);
    setFilesOriginal([]);
    setFilesSlots([]);
    setFiles([]);
    setFilesAnexo([]);
    setFilesFormData([]);
  };

  const formatSlotStatus = (rowSlotStatus) => {
    if (!rowSlotStatus) {
      return (
        <span style={{ fontWeight: "bold", color: "#FE0000" }}>
          {slotStatus("nv")}
        </span>
      );
    }

    if (rowSlotStatus === "I") {
      return (
        <span style={{ fontWeight: "bold", color: "#FE0000" }}>
          {slotStatus(rowSlotStatus)}
        </span>
      );
    }

    if (rowSlotStatus === "A") {
      return (
        <span style={{ fontWeight: "bold", color: "#97CA83" }}>
          {slotStatus(rowSlotStatus)}
        </span>
      );
    }

    if (rowSlotStatus === "C") {
      return (
        <span style={{ fontWeight: "bold", color: "#FEBC00" }}>
          {slotStatus(rowSlotStatus)}
        </span>
      );
    }

    if (rowSlotStatus === "F") {
      return (
        <span style={{ fontWeight: "bold", color: "#64B246" }}>
          {slotStatus(rowSlotStatus)}
        </span>
      );
    }

    if (rowSlotStatus === "P") {
      return (
        <span style={{ fontWeight: "bold", color: "#465eb6" }}>
          {slotStatus(rowSlotStatus)}
        </span>
      );
    }

    if (rowSlotStatus === "V") {
      return (
        <span style={{ fontWeight: "bold", color: "#ffc400" }}>
          {slotStatus(rowSlotStatus)}
        </span>
      );
    }

    if (rowSlotStatus === "D") {
      return (
        <span style={{ fontWeight: "bold", color: "#B90C78" }}>
          {slotStatus(rowSlotStatus)}
        </span>
      );
    }
  };

  const columns = [
    {
      title: "slot",
      field: "slotId",
      defaultGroupOrder: 0,
      grouping: true,
    },
    {
      title: t("forms.committeeName").toUpperCase(),
      field: "committee",
    },
    {
      title: t("meeting.meetingDate").toUpperCase(),
      field: "meetDateTime",
    },
    {
      title: t("status").toUpperCase(),
      field: "status",
      render: (rowData) => formatSlotStatus(rowData.status),
    },
    {
      title: "",
      field: "supportMaterialIndicator",
    },
  ];

  const columnsUploadTable = [
    {
      title: t("slots.fileName").toUpperCase(),
      field: "name",
      render: (rowData) => (
        <Button
          onClick={() => handleOpenFile(rowData.id)}
          style={{ textTransform: "none" }}
        >
          {rowData.name}
        </Button>
      ),
    },
    {
      title: t("typeFile").toUpperCase(),
      field: "fileTypeName",
    },
  ];

  const handleCloseDialog = () => setOpenDialog(false);

  const handleOpenDialog = (id, slotCommitteeId) => {
    handleClearList();
    setValue({ ...value, type: undefined });
    setOpenDialog(true);
    setSlotIdSelected(id);
    setSlotCommitteeIdSelected(slotCommitteeId);
    getFilesSlot(slotCommitteeId);
  };

  const handleCapture = async ({ target }) => {
    setFilesSlots(target.value);

    const listArquivos = [];

    setFilesFormData([...filesFormData, ...target.files]);
    for (const file of target.files) {
      const fileBase64 = await toBase64(file);

      const itemToInclude = {
        id: uuidv4(),
        name: file.name,
        contentType: file.type,
        contentByte: fileBase64.split(",")[1],
      };

      listArquivos.push(itemToInclude);
    }

    setFilesAnexo([...filesAnexo, ...listArquivos]);
    setFilesSlots([]);
  };

  const handleRemoveFile = (item_id) => {
    const fileToRemove = filesAnexo.find((file) => file.id === item_id);
    const newFiles = filesAnexo.filter((file) => file.id !== item_id);
    const newFilesFormData = filesFormData.filter(
      (file) => file.name !== fileToRemove.name
    );

    setFilesFormData(newFilesFormData);
    setFilesAnexo(newFiles);
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleCloseUploadSameFileDialog = () => {
    setFilesToReplace([]);
    setFilesUploadedWithSameNameState([]);
    setReplaceFileModalOpen(false);
  };

  const handleReplaceSameFile = async () => {
    if (filesToReplace.length > 0) {
      const fileIdssWithSameName = filesToReplace.map(
        (sameFile) => sameFile.id
      );
      const newFilesAnexoList = dataTableFilesUpload.filter(
        (file) => !fileIdssWithSameName.includes(file.id)
      );

      for (const fileToReplace of filesToReplace) {
        await deleteFileSlot(fileToReplace.id);
      }

      setDataTableFilesUpload([
        ...newFilesAnexoList,
        ...filesUploadedWithSameNameState,
      ]);

      setFilesAnexo([]);
      setFilesToReplace([]);
      setFilesUploadedWithSameNameState([]);
      setIdSelectedForDeleteFile(false);
    }

    setReplaceFileModalOpen(false);
  };

  const [filesToReplace, setFilesToReplace] = useState([]);
  const [filesUploadedWithSameNameState, setFilesUploadedWithSameNameState] =
    useState([]);
  const [filesFormData, setFilesFormData] = useState([]);
  const [replaceFileModalOpen, setReplaceFileModalOpen] = useState(false);

  const handleChangeSelectFileType = (selected, name) => {
    const formattedFilesAnexos = filesAnexo.filter(
      (f) =>
        !dataTableFilesUpload.find(
          (dataTableFileUpload) => dataTableFileUpload.name === f.name
        )
    );

    let modalOpen = false;

    const filesToReplaceArray = [];
    const filesUploadedWithSameNameArray = [];

    filesAnexo.forEach((fi) => {
      const dataTableFileUpload = dataTableFilesUpload.find(
        (dataTableFileUpload) => dataTableFileUpload.name === fi.name
      );

      if (dataTableFileUpload) {
        filesToReplaceArray.push(dataTableFileUpload);
        filesUploadedWithSameNameArray.push({
          ...fi,
          fileTypeName: selected.name,
          isPersisted: false,
        });

        modalOpen = true;
      }
    });

    setFilesToReplace([...filesToReplace, ...filesToReplaceArray]);
    setFilesUploadedWithSameNameState([
      ...filesUploadedWithSameNameState,
      ...filesUploadedWithSameNameArray,
    ]);

    const newFiles = formattedFilesAnexos.map((file) => {
      return {
        ...file,
        fileTypeName: selected.name,
        isPersisted: false,
      };
    });

    if (modalOpen) {
      setReplaceFileModalOpen(true);
    }

    setDataTableFilesUpload([...dataTableFilesUpload, ...newFiles]);

    setFiles([...dataTableFilesUpload, ...filesUpload]);
    setValue({ ...value, [name]: selected });
    setFilesAnexo([]);

    const newFilesFormData = filesFormData.map((file) => {
      if (!file.fileType) {
        return Object.defineProperty(file, "fileType", { value: selected.id });
      }

      return file;
    });

    setFilesFormData(newFilesFormData);

    setFilesFormData(newFilesFormData);
  };

  const handleDeleteFile = (name) => {
    const newFilesUpload = [...filesUpload];
    const newFilesOriginal = [...filesOriginal];

    const idxFileUpload = findIndex(newFilesUpload, ["name", name]);
    newFilesUpload.splice(idxFileUpload, 1);

    const idxFileUpload2 = findIndex(dataTableFilesUpload, ["name", name]);
    dataTableFilesUpload.splice(idxFileUpload2, 1);

    const idxFileUpload3 = findIndex(newFilesOriginal, ["name", name]);
    newFilesOriginal.splice(idxFileUpload3, 1);

    setFiles(newFilesUpload);
    setDataTableFilesUpload(dataTableFilesUpload);
    setFilesOriginal(newFilesOriginal);
  };

  const handleConfirmation = (id) => {
    setShowDeleteConfirmationOpen(true);
    setIdSelectedForDeleteFile(id);
  };

  const handleDownloadFile = (id, fileName) => {
    downloadFile(id, fileName)
      .then((response) => {
        if (response.error) {
          setToastMessage({
            message: response.error,
            type: "error",
            open: true,
          });
        }
      })
      .finally(() => {
        actionShowSpinner(false);
      });
  };

  const [fileOver, setFileOver] = useState(false);

  const dragOver = (e) => {
    setFileOver(true);

    e.preventDefault();
  };

  const dragEnter = (e) => {
    e.preventDefault();
  };

  const dragLeave = (e) => {
    setFileOver(false);

    e.preventDefault();
  };

  const fileDrop = async (e) => {
    setFileOver(false);
    e.preventDefault();

    const files = e.dataTransfer.files;

    const listArquivos = [];

    setFilesFormData([...filesFormData, ...files]);
    for (const file of files) {
      const fileBase64 = await toBase64(file);

      const itemToInclude = {
        id: uuidv4(),
        name: file.name,
        contentType: file.type,
        contentByte: fileBase64.split(",")[1],
      };

      listArquivos.push(itemToInclude);
    }

    setFilesAnexo([...filesAnexo, ...listArquivos]);
    setFilesSlots([]);
  };

  const handleOpenFile = (fileId) => {
    setOpenedFile(fileId);
  };

  const handleOpenUnsupportedFile = (blobUrl, fileName, fileType) => {
    setOpenedFile(null);

    setUnsuportedFileBlobUrl(blobUrl);
    setFileType(fileType);
    setFileName(fileName);
    setShowUnsuportedFileModal(true);
  };

  return (
    <>
      {openedFile && (
        <FileReaderComponent
          fileId={openedFile}
          close={() => setOpenedFile(null)}
          actionShowSpinner={actionShowSpinner}
          handleOpenUnsupportedFile={handleOpenUnsupportedFile}
        />
      )}

      <ModalBase
        open={showUnsuportedFileModal}
        setOpen={setShowUnsuportedFileModal}
        content={
          <UnsuportedFileModal
            setModalStatus={setShowUnsuportedFileModal}
            fileName={fileName}
            fileType={fileType}
            blobUrl={unsuportedFileBlobUrl}
          />
        }
      ></ModalBase>

      <Grid container className={classes.root}>
        <ToastMessage
          message={toastMessage.message}
          type={toastMessage.type || "error"}
          open={toastMessage.open}
          close={() => setToastMessage({ ...toastMessage, open: false })}
        />
        <Drawer
          anchor="right"
          open={filterDrawerOpened}
          onClose={() => {
            setFilterDrawerOpened(false);
          }}
        >
          <FilterDrawer
            actionShowSpinner={(opened) => actionShowSpinner(opened)}
            onClose={() => {
              setFilterDrawerOpened(false);
            }}
            t={t}
            setFilters={(newValues) => {
              updateFilterParams(newValues);
              updatePagination({ ...listOptions.pagination, page: 0 });
            }}
            filters={listOptions.filterParams}
          />
        </Drawer>

        <Grid item className={classes.spacer}>
          <Typography variant="h4">{t("slots.title")}</Typography>
        </Grid>

        <Grid container direction="row">
          <Paper elevation={1} className={classes.root}>
            <Grid container spacing={3}>
              <Grid item lg={12}>
                <Button
                  className={classes.filterButton}
                  startIcon={<FilterList style={{ fontSize: 30 }} />}
                  onClick={() => setFilterDrawerOpened(true)}
                >
                  {t("forms.filters")}
                </Button>
              </Grid>

              <Grid item lg={12} xs={12}>
                <Table
                  columns={columns}
                  data={formattedSlots}
                  actions={[
                    (_rowData) => {
                      if (canViewSlotCommitteeDetails) {
                        return {
                          icon: () => <Search />,
                          tooltip: "Detalhes",
                          onClick: (_event, { id, slotCommitteeId }) => {
                            history.push({
                              pathname: `/slot/committee/${id}`,
                              state: { slotCommitteeId },
                            });
                          },
                        };
                      }
                    },
                    (rowData) => {
                      return {
                        icon: () => (<CalendarToday />),
                        tooltip: t("editDate"),
                        disabled:
                          !canUpdateSlot ||
                          rowData?.slotStatusCode === "C" ||
                          rowData?.slotStatusCode === "D" ||
                          rowData?.slotStatusCode === "V",
                        onClick: (_event, { id, slotCommitteeId }) => {
                          history.push({
                            pathname: `/slot/edit/${id}`,
                            state: { editSlotCommittee: true, slotCommitteeId },
                          });
                        },
                      };
                    },
                    (_rowData) => {
                      return {
                        icon: () => <Publish />,
                        tooltip: t("documents"),
                        disabled: !canAttachFile,
                        onClick: (_event, data) => {
                          handleOpenDialog(data.id, data.slotCommitteeId);
                        },
                      };
                    },
                  ]}
                  pageSize={listOptions.pagination.size}
                  components={{
                    Pagination: (props) => {
                      return (
                        <TablePagination
                          style={{ float: "right" }}
                          rowsPerPageOptions={[5, 10, 20]}
                          rowsPerPage={listOptions.pagination.size}
                          labelRowsPerPage={t("table.labelRowsPerPage")}
                          page={listOptions.pagination.page}
                          labelDisplayedRows={(_data) => {
                            let numberOfPages = Math.ceil(
                              totalSlots / listOptions.pagination.size
                            );

                            if (numberOfPages <= 1) {
                              numberOfPages = 1;
                            }

                            return `${listOptions.pagination.page + 1} ${t(
                              "table.labelDisplayedRows"
                            )} ${numberOfPages}`;
                          }}
                          onPageChange={(_e, page) => {
                            updatePagination({
                              page: page,
                              size: listOptions.pagination.size,
                            });
                          }}
                          onRowsPerPageChange={(event) => {
                            const newSize = event.target.value;

                            updatePagination({
                              page: 0,
                              size: newSize,
                            });

                            props.onChangeRowsPerPage(event);
                          }}
                          nextIconButtonProps={{
                            disabled:
                              listOptions.pagination.page + 1 >=
                              Math.ceil(
                                totalSlots / listOptions.pagination.size
                              ),
                          }}
                          backIconButtonProps={{
                            disabled: listOptions.pagination.page <= 0,
                          }}
                        />
                      );
                    },
                    GroupRow: (rowData) => {
                      return (
                        <CustomGroupRow
                          {...rowData}
                          editIsDisabled={rowData.groupData.data.some(
                            (slot) =>
                              slot.slotStatusCode === "C" ||
                              slot.slotStatusCode === "D" ||
                              slot.extraSlot ||
                              slot.slotStatusCode === "V"
                          )}
                          handleDuplicateSlot={() => {
                            history.push({
                              pathname: "/slot/new",
                              state: {
                                duplicateSlot: true,
                                slotIdToDuplicate:
                                  rowData.groupData.data[0].slotId,
                              },
                            });
                          }}
                          handleEditSlot={(id) => {
                            if (
                              rowData.groupData.data.some(
                                (slot) =>
                                  slot.slotStatusCode === "C" ||
                                  slot.slotStatusCode === "D"
                              )
                            ) {
                              return;
                            }

                            history.push({
                              pathname: `/slot/edit/${id}`,
                              state: { editSlotCommittee: false },
                            });
                          }}
                          isExpanded={true}
                          t={t}
                        />
                      );
                    },
                  }}
                />
              </Grid>

              <Grid item lg={12}>
                {successDeletedState && (
                  <Grid
                    container
                    item
                    direction="row"
                    alignItems="center"
                    justify="center"
                    className={classes.success}
                  >
                    <Grid item>
                      <Cancel className={classes.icon} />
                    </Grid>
                    <Grid item>
                      <Typography className={classes.label}>
                        {t("deleteSuccess").toUpperCase()}
                      </Typography>
                    </Grid>
                  </Grid>
                )}

                {successCreatedState && (
                  <Grid
                    container
                    item
                    direction="row"
                    alignItems="center"
                    justify="center"
                    className={classes.success}
                  >
                    <Grid item>
                      <CheckCircleRounded className={classes.icon} />
                    </Grid>
                    <Grid item>
                      <Typography className={classes.label}>
                        {t("addSuccess").toUpperCase()}
                      </Typography>
                    </Grid>
                  </Grid>
                )}

                {successUpdatedState && (
                  <Grid
                    container
                    item
                    direction="row"
                    alignItems="center"
                    justify="center"
                    className={classes.success}
                  >
                    <Grid item>
                      <CheckCircleRounded className={classes.icon} />
                    </Grid>
                    <Grid item>
                      <Typography className={classes.label}>
                        {t("editSuccess").toUpperCase()}
                      </Typography>
                    </Grid>
                  </Grid>
                )}

                {successDisabledState && (
                  <Grid
                    container
                    item
                    direction="row"
                    alignItems="center"
                    justify="center"
                    className={classes.success}
                  >
                    <Grid item>
                      <CheckCircleRounded className={classes.icon} />
                    </Grid>
                    <Grid item>
                      <Typography className={classes.label}>
                        {t("disabledSuccess").toUpperCase()}
                      </Typography>
                    </Grid>
                  </Grid>
                )}

                {successEnabledState && (
                  <Grid
                    container
                    item
                    direction="row"
                    alignItems="center"
                    justify="center"
                    className={classes.success}
                  >
                    <Grid item>
                      <CheckCircleRounded className={classes.icon} />
                    </Grid>
                    <Grid item>
                      <Typography className={classes.label}>
                        {t("enabledSuccess").toUpperCase()}
                      </Typography>
                    </Grid>
                  </Grid>
                )}

                {filesUploadedSuccess && (
                  <Grid
                    container
                    item
                    direction="row"
                    alignItems="center"
                    justify="center"
                    className={classes.success}
                  >
                    <Grid item>
                      <CheckCircleRounded className={classes.icon} />
                    </Grid>
                    <Grid item>
                      <Typography className={classes.label}>
                        {t("fileUploadSuccess").toUpperCase()}
                      </Typography>
                    </Grid>
                  </Grid>
                )}

                {filesUploadedError && (
                  <Grid
                    container
                    item
                    direction="row"
                    alignItems="center"
                    justify="center"
                    className={classes.error}
                  >
                    <Grid item>
                      <Cancel className={classes.icon} />
                    </Grid>
                    <Grid item>
                      <Typography className={classes.label}>
                        {filesUploadedErrorMessage
                          ? filesUploadedErrorMessage
                          : t("fileUploadError").toUpperCase()}
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid container item direction="row" justify="center">
          <Grid item>
            <Button
              className={classes.button}
              variant="contained"
              startIcon={<AddCircleRounded style={{ fontSize: 30 }} />}
              onClick={() => history.push("/slot/new")}
              disabled={!canCreateSlot}
            >
              {t("slots.addSlotTable")}
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <DialogCustom
        open={openDialog}
        handleClose={handleCloseDialog}
        title={t("addFile")}
        showBtnSave={false}
        showBtnConfirmSlot={true}
        handleSaveSlot={saveSlot}
        slotSaveLoading={saveLoading}
      >
        <Grid container spacing={3}>
          <Grid item lg={12} xs={12}>
            <Button
              variant="contained"
              color="primary"
              component="label"
              fullWidth
            >
              {t("chooseFile")}
              <input
                type="file"
                hidden
                multiple="multiple"
                value={filesSlots}
                onChange={handleCapture}
              />
            </Button>
            <Dropzone
              onDragOver={dragOver}
              onDragEnter={dragEnter}
              onDragLeave={dragLeave}
              onDrop={fileDrop}
              style={fileOver ? { borderColor: "#465eb6" } : {}}
            >
              <p>Arraste os arquivos para cá.</p>
            </Dropzone>

            <Box className={classes.lgpdInfoContainer}>
              <FieldInfo>
                Certifique-se de que o documento anexado contém apenas as
                informações necessárias para o andamento dessa atividade
              </FieldInfo>
            </Box>
          </Grid>
          <Grid item lg={12} xs={12}>
            {filesAnexo.map((item) => (
              <FilesContainer key={item.id}>
                <p>{item.name}</p>
                <DeleteOutlined onClick={() => handleRemoveFile(item.id)} />
              </FilesContainer>
            ))}
          </Grid>
          <Grid item lg={12} xs={12}>
            <Select
              id="type"
              options={fileTypes}
              value={value.type}
              setValue={(value) => handleChangeSelectFileType(value, "type")}
              label={t("typeFile")}
            />
          </Grid>
          {dataTableFilesUpload.length > 0 && (
            <Grid item lg={12} xs={12}>
              <Table
                columns={columnsUploadTable}
                data={dataTableFilesUpload}
                actions={[
                  {
                    icon: () => <Delete />,
                    tooltip: t("delete"),
                    onClick: (_event, dataRow) => {
                      if (dataRow.isPersisted) handleConfirmation(dataRow.id);
                      else handleDeleteFile(dataRow.name);
                    },
                  },
                  {
                    icon: () => <CloudDownload />,
                    tooltip: t("download"),
                    onClick: (_event, dataRow) => {
                      if (!dataRow.isPersisted) {
                        setToastMessage({
                          message: t("slots.fileNotPersistedError"),
                          type: "error",
                          open: true,
                        });

                        return;
                      }

                      handleDownloadFile(dataRow.id, dataRow.name);
                    },
                  },
                ]}
              />
            </Grid>
          )}
        </Grid>
      </DialogCustom>

      <DialogConfirmation
        open={showDeleteConfirmationOpen}
        handleClose={() => setShowDeleteConfirmationOpen(false)}
        handleChange={deleteFilePersist}
        title={t(`forms.dialog.warning`)}
        body={t("slots.deleteFileText")}
        confirmText={t(`forms.dialog.yes`)}
        cancelText={t(`forms.dialog.no`)}
        error={true}
      />

      <DialogConfirmation
        open={replaceFileModalOpen}
        handleClose={handleCloseUploadSameFileDialog}
        handleChange={handleReplaceSameFile}
        title={t(`forms.dialog.alert`)}
        body={t("forms.dialog.uploadSameFile")}
        confirmText={t(`forms.dialog.yes`)}
        cancelText={t(`forms.dialog.no`)}
        alert={true}
      />
    </>
  );
};

const withRouterListSlots = withRouter(ListSlots);

const mapDispatchToProps = (dispatch) => ({
  actionShowSpinner: (request) => dispatch(actionShowSpinner(request)),
});

const ListSlotsConnect = connect(null, mapDispatchToProps)(withRouterListSlots);

export default withTranslation()(ListSlotsConnect);
